import {
	Card,
	Form,
	Input,
	Button,
	Select,
	Row,
	Col,
	Typography,
	message,
	notification,
	Space,
} from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppContext from "../../store/app.context";
import { requestCreateCustomer } from "../../services/admin.service";
import { PiArrowLeftDuotone } from "react-icons/pi";

const { Title } = Typography;
const { Option } = Select;

// Constants based on actual user data structure
const ROLE_OPTIONS = [
	{ label: "User", value: "USER" },
	{ label: "Admin", value: "ADMIN" },
];

function AddCustomerPage() {
	const context = useContext(AppContext);
	const navigate = useNavigate();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		document.title = "Cloudiva Console | Add User";
	}, []);

	const handleSubmit = () => {
		form
			.validateFields()
			.then((values) => {
				setLoading(true);

				// Process the form data to match the actual user data structure
				const userData = {
					name: values.name,
					email: values.email,
					phone: values.phone?.startsWith("+") ? values.phone : `+${values.phone}`,
					role: values.role || "USER",
					password: values.password || "defaultPassword123", // You may want to generate or require this
					permissions: [], // Empty array as shown in the data structure
					teamIds: [], // Empty array initially, can be managed separately
					deleted: false,
				};

				requestCreateCustomer(userData)
					.then(() => {
						message.success("User created successfully!");
						navigate("/customers");
					})
					.catch((error) => {
						console.error("Error creating user:", error);
						if (error.response?.data?.message) {
							notification.error({
								message: "Error",
								description: error.response.data.message,
							});
						} else {
							notification.error({
								message: "Error",
								description: "Failed to create user. Please try again.",
							});
						}
					})
					.finally(() => {
						setLoading(false);
					});
			})
			.catch((error) => {
				console.error("Validation failed:", error);
			});
	};

	const validateJSON = (_, value) => {
		if (!value) return Promise.resolve();
		try {
			JSON.parse(value);
			return Promise.resolve();
		} catch (error) {
			return Promise.reject(new Error("Please enter valid JSON"));
		}
	};

	return (
		<div className="page-content">
			<div style={{ marginBottom: 24 }}>
				<Space>
					<Button icon={<PiArrowLeftDuotone />} onClick={() => navigate("/customers")}></Button>
					<Title level={4} style={{ margin: 0 }}>
						Add User
					</Title>
				</Space>
			</div>
			<div className="page-content-wrapper">
				<Card
					title="Create New User"
					extra={
						<div>
							<Button onClick={() => navigate("/customers")} style={{ marginRight: 8 }}>
								Cancel
							</Button>
							<Button type="primary" loading={loading} onClick={handleSubmit}>
								Create User
							</Button>
						</div>
					}>
					<Form form={form} layout="vertical">
						{/* Basic Information */}
						<Row gutter={16}>
							<Col span={8}>
								<Form.Item
									label="Full Name"
									name="name"
									rules={[{ required: true, message: "Please enter user name" }]}>
									<Input placeholder="Enter full name" />
								</Form.Item>
							</Col>
							<Col span={8}>
								<Form.Item
									label="Email Address"
									name="email"
									rules={[
										{ required: true, message: "Please enter email address" },
										{ type: "email", message: "Please enter a valid email address" },
									]}>
									<Input placeholder="Enter email address" />
								</Form.Item>
							</Col>
							<Col span={8}>
								<Form.Item
									label="Phone Number"
									name="phone"
									rules={[{ required: true, message: "Please enter phone number" }]}>
									<Input placeholder="Enter phone number" />
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={16}>
							<Col span={8}>
								<Form.Item
									label="Role"
									name="role"
									initialValue="USER"
									rules={[{ required: true, message: "Please select user role" }]}>
									<Select placeholder="Select user role">
										{ROLE_OPTIONS.map((option) => (
											<Option key={option.value} value={option.value}>
												{option.label}
											</Option>
										))}
									</Select>
								</Form.Item>
							</Col>
							<Col span={8}>
								<Form.Item
									label="Password"
									name="password"
									rules={[
										{ required: true, message: "Please enter password" },
										{ min: 6, message: "Password must be at least 6 characters" },
									]}>
									<Input.Password placeholder="Enter password" />
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Card>
			</div>
		</div>
	);
}

export default AddCustomerPage;
